import React from "react";

const NotFoundPage = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "600px" }}
    >
      <div className="card p-4 rounded">La Pagina Que Busca No Existe xDD</div>
    </div>
  );
};

export default NotFoundPage;
